module.exports = __webpack_public_path__ + "static/media/follow_up_visits_big.1ee6ca77.png";